module.exports = __webpack_public_path__ + "media/images/button_arrow_green-b8e3781284ef75a65760c90accb96f93.png";